export const REMINDER_HIGHLIGHT_DURATION_MS = 2500;
